"use client"
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { LanguageToggle } from "@/components/layout/LanguageToggle"
import { HealthConsentScreen } from "./HealthConsentScreen"

/**
 * The blocking full-page gate: shown INSTEAD of the app (Today, Plan, Kitchen, Shop, More, Amy) for an
 * account whose onboarding is complete but which has no active health/AI consent, and for any 403
 * HEALTH_AI_CONSENT_REQUIRED. No navigation chrome — there is nothing to open until the answer is in.
 * The language toggle stays: the wording being consented to must be readable in the user's language.
 */
export function HealthConsentGate({ onConsented }: { onConsented?: () => void }) {
  return (
    <div className="flex min-h-screen flex-col gap-8 bg-cream px-4 py-10">
      <div className="mx-auto flex w-full max-w-2xl justify-end">
        <LanguageToggle />
      </div>
      <HealthConsentScreen onConsented={() => onConsented?.()} />
    </div>
  )
}
